module.exports = __webpack_public_path__ + "static/media/Hippowdon_gaussian2.c0dcf420.png";